<template>
  <div class="shop-cart">
    <Breadcrumb />

    <div class="shop-table">
      <!-- 标题 -->
      <el-row :gutter="10">
        <el-col :span="4"> 我的购物车 </el-col>
        <el-col :span="14" :offset="6">
          <el-steps :active="active" align-center class="step">
            <el-step title="查看购物车"></el-step>
            <el-step title="确认订单信息"></el-step>
            <el-step title="完成支付"></el-step>
          </el-steps>
        </el-col>
      </el-row>

      <!-- 无数据 -->
      <div class="empty-cart" v-if="tableData.length <= 0 && tableDataFlb.length <= 0">
        <div class="e_icon_content">
          <img src="../../../assets/images/emptyCart.png" class="empty-img" />
          <span style="font-size: 20px"> 购物车空空如也,赶紧去 </span>
          <router-link to="/select/custom/list" class="r_link">
            <span style="font-size: 20px; color: #1296db"> 逛逛吧！ </span>
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="tableData.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：莆田
        </div>
      </div>
      <el-table :data="tableData" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#409eff' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableDataFlb.length > 0" class="tab-content border">
      <div
        style="
                text-align: left;
                padding: 0 16px 0 0;
                font-weight:bold;
                position: absolute;
                left: 24px;
                top: 12px;
                min-width: 620px;
                z-index: 99;
                font-size: 13px;
                color: #606266 !important;
              "
      >
        <div style="display: inline-block;float:left;">
          生产区域：菲律宾
        </div>
      </div>
      <el-table :data="tableDataFlb" stripe ref="shopCartTable">
        <el-table-column align="center" width="60">
          <template slot-scope="scope">
            <el-checkbox
              :disabled="scope.row.dzStatus == '02'"
              @change="handleSelectionChange"
              v-model="scope.row.checked"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="500">
          <template slot-scope="scope">
            <div class="tab-sku-col">
              <div class="sku-img" style="width: 240px; position: relative">
                <div
                  :style="{
                    background:
                      scope.row.productType == '01' ? '#409eff' : '#ff9000',
                  }"
                  class="product-type"
                >
                  {{ scope.row.productType == "01" ? "定制" : "优选" }}
                </div>
                <img
                  :src="
                    scope.row.activeSku &&
                    scope.row.activeSku.picList &&
                    scope.row.activeSku.picList.length > 0
                      ? scope.row.activeSku.picList[0].picUrl
                      : ''
                  "
                />
                <div class="sku-title">
                  {{ scope.row.proName }}
                </div>
              </div>
              <div class="sku-attr">
                <el-row
                  v-for="(i, ind) in [0, 1]"
                  :key="'i_' + ind"
                  style="margin: 5px 0"
                >
                  <div class="proper">
                    <span class="name">
                      {{
                        scope.row.activeSku &&
                          scope.row.activeSku.properName.split(":")[i]
                      }}:
                    </span>
                    <span v-if="scope.row.activeSku" class="value">
                      <el-select
                        v-model="scope.row.activeSku.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(
                              value,
                              i,
                              scope.row,
                              scope.row.activeSku
                            )
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in JSON.parse(
                            scope.row.attribute
                          )[scope.row.activeSku.properName.split(':')[i]]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>¥ {{ scope.row.unitPrice }}</div>
              <div
                class="delete"
                v-if="scope.row.unitPrice !== scope.row.sellPrice"
              >
                ¥ {{ scope.row.sellPrice }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="刺绣单价" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <div>
                ¥
                {{ scope.row.embroideryPrice ? scope.row.embroideryPrice : 0 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-input-number
                size="small"
                :precision="0"
                :min="1"
                :max="99999"
                :step="1"
                step-strictly
                v-model.number="scope.row.productNum"
                @change="(val) => getSubtotal(val, scope.row)"
              />
            </div>
            <div style="margin: 7px 0 0 0; color: #cccccc" class="center">
              {{ scope.row.moq }}件起订
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center font-red">¥ {{ scope.row.totalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class="pro-col">
          <template slot-scope="scope">
            <div class="center">
              <el-button
                type="text"
                class="font-red"
                size="mini"
                @click="removerRow(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-content bottom-sticky">
      <el-row type="flex" style="margin-bottom: 0px">
        <el-col :span="4">
          <el-checkbox
            v-model="ifCheckAll"
            :indeterminate="isIndeterminate"
            @change="checkAll"
            >全选</el-checkbox
          >
        </el-col>
        <el-col class="cart-info" :span="17">
          <span>
            共
            <span class="font-red">{{ proAmountTotal }}</span>
            件商品, 已选择
            <span class="font-red">{{ Number(checkCount) }}</span>
            件
          </span>
          <el-divider direction="vertical"></el-divider>
          <span> 合计（不含运费）： </span>
          <span class="large-price form-required">¥ {{ total }}</span>
        </el-col>
        <el-col class="pay-btn text-noSelect" :span="3">
          <div @click="settlement" class="settle-btn">下单</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {
  listCart,
  delCart,
  updateCart,
  updateCartCount,
  selectCart
} from '@/api/order/cart'

export default {
    name: "shoppingCart",
    components:{
      Breadcrumb
    },
    data(){
      return {
        tableData: [],
        tableDataFlb: [],
        ifCheckAll: false,
        isIndeterminate: false,
        proAmountTotal: 0, // 商品总件数
        checkCount: 0, // 选中商品数
        total: 0, // 商品总价
        checkList: [], //选中的数据
        active: 1,
        isRefresh: false
      }
    },
    async mounted(){
      await this.loadData();

      this.ifCheckAll = true
      this.checkAll()
    },
    watch: {
      tableData() {
        this.$nextTick(() => {
          // this.tableData.length > 0 && this.$refs.shopCartTable.toggleAllSelection();
          this.calculate();
        })
      }
    },
    methods: {
      // 获取数据
     async  loadData() {
        this.startLoading()
        this.proAmountTotal = 0
        let res = await listCart()

        res.rows.forEach(row => {
          if(row.skuList){
            row.skuList.map(el => {
              if (row.skuId === el.skuId) {
                row['activeSku'] = el
              }
            })
            this.proAmountTotal += Number(row.productNum)
            row.checked = false;
          }

        });

        res.rows.map(record=>{
          for(let item of this.checkList){
            if(item.cartId == record.cartId){
              record.checked = true
              item.productNum = record.productNum
              item.totalPrice = record.totalPrice
              item.embroideryCost  = record.embroideryCost
              item.embroideryPrice  = record.embroideryPrice
            }
          }
        })
        this.tableData = res.rows.filter((record)=>{
          return record.manufacturer == '01'
        })

        this.tableDataFlb = res.rows.filter((record)=>{
          return record.manufacturer == '02'
        })

        this.calculate();
        this.endLoading();
      },
      changeProper(data, index, row, active) {
        let skuId = ''
        const properVal0 = active.properVal.split(':')[0]
        const properVal1 = active.properVal.split(':')[1]
        let newProperVal = ''

        if (index === 0) {
          newProperVal = data + ':' + properVal1
        }
        if (index === 1) {
          newProperVal = properVal0 + ':' + data
        }

        row.skuList.map(el => {
          if (el.properVal.replace(/\\/g, '') === newProperVal) {
            skuId = el.skuId
          }
        })

        updateCart({
          cartId: row.cartId,
          skuId: skuId
        }).then((res) => {
          if (res.code === 200) {
            this.loadData()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error.msg)
        });
      },
      // 删除商品
      removerRow(row) {
        this.$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCart(row.cartId).then(res => {
            if (res.code === 200) {
              this.$store.dispatch("GetIndexStat")
              this.$message.success('删除成功')
              //删除
              for(let i = 0;i< this.checkList.length;i++){
                if(this.checkList[i].cartId == row.cartId){
                  this.checkList.splice(i, 1)
                  break
                }
              }
              this.loadData()
            } else {
              this.$message.error(res.msg)
            }
          }).catch(error => {
            this.$message.error(error.msg)
          });
        });
      },
      // 下单结算
      settlement() {
        if (this.checkList.length == 0) {
          this.$message.info("您还没有选择商品哦")
        } else {
          const type = []
          let manufacturer = []
          this.checkList.map(el => {
            type.push(el.productType)
            manufacturer.push(el.manufacturer)
          })
          console.log('type ------------', this._.union(type))

          if (this._.union(type).length > 1) {
            this.$message.info("不同类型商品不可一起付款哦")
          } else if (this._.union(manufacturer).length > 1) {
            this.$message.info("不同生产厂商不可一起付款哦")
          }else {
            //判断数量
            let product = {}
            for(let record of this.checkList){
              if(!product[record.pId]){
                product[record.pId] = {
                  productNum: Number(record.productNum),
                  moq: record.moq,
                  proName: record.proName
                }
              } else{
                product[record.pId].productNum +=  Number(record.productNum)
              }
            }

            for(let record in product){
                if(product[record].productNum < product[record].moq){
                this.$message.info(`${product[record].proName}不能低于起订数量${product[record].moq}件`)
                return
              }
            }

            sessionStorage.setItem("settlement", JSON.stringify(this.checkList));

            this.$router.push({
              path: '/order/myOrder/settlement'
            })
          }
        }
      },
      // 选中所有行
      async checkAll(val) {
        this.isIndeterminate = false;

        let cartArray = []
        this.tableData.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: this.ifCheckAll ? '1' : '0'
          })
        })

        await selectCart(cartArray)

        await this.loadData()

        this.checkList = []

        this.tableData.map(record=>{
          if(this.ifCheckAll && record.dzStatus == '01'){
            this.checkList.push(record)
          }
          record.checked = this.ifCheckAll && record.dzStatus == '01' ? true : false
        })


        this.calculate()
      },
      // 更新数量
      getSubtotal(val, row) {
        updateCartCount({
          productNum: val,
          cartId: row.cartId,
          skuId: row.skuId
        }).then(res => {
          if (res.code === 200) {
            this.loadData()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error.msg)
        });
      },
      // 行勾选事件
      async handleSelectionChange(val) {
        this.startLoading()
        this.isIndeterminate = val.length > 0 && val.length < this.tableData.length;
        this.checkList = []
        let cartArray = []

        this.tableData.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

         this.tableDataFlb.map(record=>{
          if(record.checked){
            this.checkList.push(record)
          }
          cartArray.push({
              cartId: record.cartId,
              selectFlag: record.checked ? '1' : '0'
          })
        })

        await selectCart(cartArray)


        await this.loadData()

        this.calculate();
      },
      // 计算商品合计、实付金额
      calculate () {
        this.checkCount = 0
        this.total = 0;
        this.checkList.forEach(row =>{
          this.checkCount += Number(row.productNum)
          this.total += Number(row.totalPrice)
        });
        this.total =  Math.round(this.total * 100) / 100
      }
    },
}
</script>

<style scoped lang="scss">
.shop-cart {
  height: 100%;

  .shop-table {
    padding: 18px;
    border: 1px solid #ebeef5;
    background: #fff;
    font-size: 14px;
    overflow: hidden;
    color: #595a5a;

    .step {
      position: relative;
      right: -75px;
      top: 7px;
    }
  }

  .empty-img {
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-direction: column;

  .delete {
    color: #ccc;
    text-decoration: line-through;
  }
}
.product-type {
  position: absolute;
  left: 56px;
  top: 0;
  border-color: rgb(255, 144, 0);
  background-color: rgb(255, 144, 0);
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.tab-content {
  position: relative;
}
</style>
